export default __webpack_public_path__ + "static/dotter-9f9b9528e17a452e364fafee8c7f1a16.jpg";